import accordionVariables from './accordionVariables';

export default accordionVariables;
